var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEKtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2502_22259)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 18.5,
    stroke: "#C598E5",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2502_22259",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49094 22C1.56295 22 -0.0282746 23.5726 0.276388 25.4764C0.735777 28.347 1.76155 31.1099 3.30653 33.5997C5.46783 37.0828 8.55925 39.8927 12.2322 41.7127C15.9051 43.5327 20.0135 44.2903 24.094 43.9001C27.0109 43.6212 29.8306 42.7637 32.3929 41.3904C34.0922 40.4796 34.3796 38.2609 33.2117 36.7269V36.7269C32.0439 35.1929 29.8616 34.9405 28.0998 35.7236C26.6262 36.3785 25.0498 36.795 23.4294 36.9499C20.6439 37.2163 17.8394 36.6991 15.3321 35.4567C12.8248 34.2143 10.7145 32.2961 9.23906 29.9185C8.38082 28.5354 7.75728 27.0288 7.3858 25.4596C6.94165 23.5835 5.41894 22 3.49094 22V22Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.49094 22C1.56295 22 -0.0282746 23.5726 0.276388 25.4764C0.735777 28.347 1.76155 31.1099 3.30653 33.5997C5.46783 37.0828 8.55925 39.8927 12.2322 41.7127C15.9051 43.5327 20.0135 44.2903 24.094 43.9001C27.0109 43.6212 29.8306 42.7637 32.3929 41.3904C34.0922 40.4796 34.3796 38.2609 33.2117 36.7269V36.7269C32.0439 35.1929 29.8616 34.9405 28.0998 35.7236C26.6262 36.3785 25.0498 36.795 23.4294 36.9499C20.6439 37.2163 17.8394 36.6991 15.3321 35.4567C12.8248 34.2143 10.7145 32.2961 9.23906 29.9185C8.38082 28.5354 7.75728 27.0288 7.3858 25.4596C6.94165 23.5835 5.41894 22 3.49094 22V22Z",
    stroke: "#74BCBE",
    strokeWidth: 14,
    mask: "url(#path-3-inside-1_2502_22259)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 30,
    height: 19,
    rx: 1,
    fill: "#530F7A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 30,
    height: 19,
    rx: 1,
    fill: "#863DC4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 14,
    width: 8,
    height: 11,
    rx: 1,
    fill: "#A978D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: "#A978D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 16,
    width: 12,
    height: 1,
    rx: 0.5,
    fill: "#A978D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "#A978D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 20,
    width: 14,
    height: 1,
    rx: 0.5,
    fill: "#A978D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 22,
    width: 10,
    height: 1,
    rx: 0.5,
    fill: "#A978D4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 27,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#530F7A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2502_22259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEKtp);
export default __webpack_public_path__ + "static/media/e_ktp.36c9a7d56c89abe2c9498768afe6e612.svg";
export { ForwardRef as ReactComponent };